import React from 'react';
import type { DashboardMetric } from '../types/Dashboard';
import Unit from '../../../components/Modular/Unit';
import NanoUnit from '../../../components/Modular/NanoUnit';
import MicroUnit from '../../../components/Modular/MicroUnit';
import './DashboardCard.css';

interface DashboardCardProps {
  metric: DashboardMetric;
  gridArea: string;
}

const DashboardCard = ({ metric, gridArea }: DashboardCardProps) => {
  return (
    <Unit
      as="div"
      height="3"
      width="6"
      borderRadius="md"
      background="surface"
      layout="flex"
      paddingLeft="md"
      paddingTop="md"
      paddingRight="md"
      paddingBottom="md"
      justifyContent="center"
      className="item"
      gridArea={gridArea}
    >
      <MicroUnit as="h2" h2Typography="subtitle" h2Color="text-light">
        {metric.label}
      </MicroUnit>
      <MicroUnit as="h2" h2Typography="subtitle" h2Color="text-light">
        {metric.value}
      </MicroUnit>
      {metric.description && <p>{metric.description}</p>}
    </Unit>
  );
};

export default DashboardCard;
